if (!customElements.get('header-back')) {
  class HeaderBack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const details = this.closest('details');
        if (!details) return;

        const activeAccordions = details.querySelectorAll(
          'accordion-item.is-active > .js-accordion-head',
        );
        if (!activeAccordions) return;

        activeAccordions[activeAccordions.length - 1].click();
      });
    }
  }

  customElements.define('header-back', HeaderBack);
}
